export default "__VITE_ASSET__DMJDQRbg__"